//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import Groups from 'src/components/Groups';
import { dialog } from 'src/boot/mixins.js';
export default {
  mixins: [dialog],
  components: {
    TeDialog: TeDialog,
    Groups: Groups
  }
};